export const colors = {
  brand: {
    500: "#f75f2d",
    600: "#be4720",
  },
  discord: {
    500: "#4752c4",
    600: "#3c45a5",
  },
  ink: {
    DEFAULT: "#1a1919",
    light: "#f5f3f0",
    light2: "#b2b1af",
  },
  surface: {
    DEFAULT: "#f5f3f0",
    white: "#ffffff",
    dark: "#000000",
    darkSoft: "#262625",
  },
  warm: {
    300: "#cccac8",
    500: "#949390",
    600: "#6e6e6b",
    700: "#474746",
  },
  line: {
    hairline: "rgba(26, 25, 25, 0.14)",
    glass: "rgba(148, 147, 144, 0.35)",
    glassBorder: "rgba(229, 227, 224, 0.2)",
  },
};
